module.exports = __webpack_public_path__ + "static/img/banner-18-sept-itali.68dcbaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-18-sept-itali.png
// module id = tA1X
// module chunks = 1